/**
 * Included into the footer of pages.
 */

import * as variables from './variables';

import $ from 'jquery';

import './lib/AnimationEasing';

import "./lib/AnalyticsSetup";

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import { MainMenu, CollapseExpandChildrenListener } from './component/MainMenu';
new MainMenu({
	menu: '#menu',
	menuTriggers: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.node--hasChild > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(400, 'easeOutExpo')
	]
});



//===================================================================
// Plaudit Query Loop - 'Our Project' Filters
//===================================================================
const pqlProjects = $(".plauditQueryLoop--projects");

if(pqlProjects.length !== 0) {

	// Common Selectors
	const $fieldsets = $('.dropdown__fieldset');
	const $checkboxes = $fieldsets.find('input[type="checkbox"]');

	// Closes all project filters when clicking outside of fieldsets
	$(document).on("click", function (e) {
		if (!$(e.target).closest($fieldsets).length) {
			$fieldsets.removeClass("active");
		}
	});

	// Opens/Closes project filter dropdowns
	$fieldsets.on("click", function () {
		$fieldsets.not(this).removeClass("active"); // Close other fieldsets
		$(this).toggleClass("active"); // Toggle active class on clicked fieldset
	});

	// Checkbox Click Handler
	$checkboxes.on("click", function() {
		const $checkbox = $(this);
		const label = $checkbox.attr('data-label');

		if($checkbox.is(":checked")) {
			addItem(label);
		} else {
			removeItem(label);
		}
	});

	// Clear anchors on reset link click
	$(".wp-block-plaudit-query-loop-reset-link").on("click", function() {
		$(".acf-innerblocks-container a").remove();
	});

	// Prevents the checkboxes from closing the dropdown
	$('fieldset[data-tag="checkbox"] input[type="checkbox"], fieldset[data-tag="checkbox"] label, .plauditQueryLoopField__inputList').on("click", function(e){
		e.stopPropagation();
	});

	// Item click handler
	pqlProjects.on("click", ".acf-innerblocks-container a", function(e) {
		e.preventDefault();
		const $link = $(this);
		const label = $link.text();
		$link.remove();
		removeItem(label);
	});

	function addItem(label:any) {
		const container = findContainer(label);
		container.append(`<a href="" class="filter">${label}</a>`);
	}

	function removeItem(label:any) {
		$(`.acf-innerblocks-container a:contains(${label})`).remove();
		const $checkbox = $(`input[data-label="${label}"]`);
		$checkbox.prop("checked", false);
		$checkbox.get(0).dispatchEvent(new CustomEvent("input", {bubbles: true}));
	}

	function findContainer(label:any) {
		return $(`input[data-label="${label}"]`)
				.closest("fieldset")
				.find(".acf-innerblocks-container");
	}
}
// ---------------------------------------------------------------------------------------------- //



//===================================================================
// Adds classes to body as we scroll
//===================================================================
import Scrolled from './component/Scrolled';
new Scrolled({
	scrolledClass: 'hasScrolled',
	scrolledDistanceClass: 'hasScrolledDistance',
	scrollDistanceDown: 40,
	scrollDistanceUp: 20
});
//===================================================================



//===================================================================
// In Page Menu (What We Do page)
// Created when #processBlocks exists
//===================================================================
const hasInPageMenu = $("#processBlocks");

if(hasInPageMenu.length !== 0) {
	const items = $(".processBlock"); /* get all .processBlock */
	const firstItemId = items.first().find("a").attr('href'); /* get the href/ID from the first item */


	// Builds the In Page Menu.
	$(function() {
		var menuList = $('<ul>');
		items.each(function() {
			var heading = $(this).find('.wp-block-heading').text();
			var link = $(this).find('.processBlock__fullLink').attr('href');
			var dataId = link.replace('#', '');
			menuList.append('<li><a data-id="' + dataId + '" href="' + link + '" class="inPageMenu__link">'+ heading +'</a></li>');
		});
		menuList.append('</ul>');
		const menuHtml = menuList.get(0).outerHTML;
		$('<div>', {
			'class': 'inPageMenu fixed'
		}).html('<div class="inPageMenu__inner">' + menuHtml + '</div>').insertAfter('.pageHeader').insertBefore('.pageContent');
	});


	// Checks position of blocks on scroll and determines which is mostly in view, sets 'active' class on the appropriate anchor.
	function trackActiveItem() {
		var div = $('.pageContent > ' + firstItemId);
		var pos = div.offset().top;
		var menuLinks = $('.inPageMenu .inPageMenu__link');
		var pageContent = document.querySelector('.pageContent');
		var children = pageContent.children;
		var activeId;
		var mostInView = 0;

		// adds 'active' class to inPageMenu when scroll reaches 200px
		if($(window).scrollTop() > pos - 200){
			$('.inPageMenu').addClass('active');
		} else {
			$('.inPageMenu').removeClass('active');
		}

		for (var i = 0; i < children.length; i++) {
		  	var item = children[i];
		  	var rect = item.getBoundingClientRect();
		  	var inViewPx = Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top);

			if (inViewPx > mostInView) {
				activeId = item.id;
				mostInView = inViewPx;
			}
		}

		var newActive = document.getElementById(activeId);

		for (var i = 0; i < menuLinks.length; i++) {
			if (newActive.id == menuLinks[i].getAttribute('data-id')) {
				menuLinks[i].classList.add('active');
			} else {
				menuLinks[i].classList.remove('active');
			}
		}
	}

	window.addEventListener('scroll', trackActiveItem);
}
//===================================================================




//===================================================================
// Colorbox
//===================================================================
import 'jquery-colorbox';
import Colorbox from './component/Colorbox/Colorbox'
new Colorbox();
//===================================================================

//===================================================================
// Video - Lightbox
//===================================================================
import VideoLightbox from './component/VideoLightbox';
VideoLightbox();
//===================================================================




//===================================================================
// Interactive Map - Desktop - Contact Page
//===================================================================
const interactiveMap = $(".map--contact");

if ( interactiveMap.length !== 0 ) {
	const officeIcons = $(".office"); 							// gets all office icons
	const regions = $(".region"); 								// gets all map regions
	const regionalCards = $(".regionalCard"); 					// gets all regional cards
	const regionalCardTitles = $('.regionalCard__titleLink'); 	// gets each of the regional card title anchors
	const contactCards = $('.contactCard'); 					// gets all of the regional cards contact cards


	// Updates Map Icons
	// --------------------------------------------------------------
	// function updateMapIcon(data:any) {
	// 	for (var i = 0; i < officeIcons.length; i++) {
	// 		var $officeId = $(officeIcons[i]).attr('data-icon-id');

	// 		if (data === $officeId) {
	// 			$(officeIcons[i]).addClass("active");
	// 		} else {
	// 			$(officeIcons[i]).removeClass("active");
	// 		}
	// 	}
	// }
	// --------------------------------------------------------------


	// Updates Contact Cards (inside the region cards)
	// --------------------------------------------------------------
	// function updateContactCard(data:any) {
	// 	console.log('Card Clicked: ', data);
	// 	for (var i = 0; i < contactCards.length; i++) {
	// 		var $contactCards = $(contactCards[i]).attr('id');

	// 		if (data === $contactCards) {
	// 			$(contactCards[i]).addClass("active");
	// 		} else {
	// 			$(contactCards[i]).removeClass("active");
	// 		}
	// 	}
	// }
	// --------------------------------------------------------------


	// Checks Hash Value
	// --------------------------------------------------------------
	function checkHashValue() {
		var newHash = location.hash;

		// Removes hash if it exists
		if (newHash.startsWith('#')) {
			newHash = newHash.slice(1);
		}

		// Makes the appropriate Regional Card active if the card id matches the hash.
		for (var i = 0; i < regionalCards.length; i++) {
			var regionalCardId = regionalCards[i].getAttribute('id');

			if (newHash === regionalCardId) {
				$(regionalCards[i]).addClass('active');
			} else {
				$(regionalCards[i]).removeClass('active');
			}
		}
	}
	// --------------------------------------------------------------


	// Listeners
	// --------------------------------------------------------------
	window.addEventListener('load', checkHashValue);
	window.addEventListener('hashchange', checkHashValue);

	regions.on('click', () => {
		checkHashValue();
		officeIcons.removeClass('active');
		contactCards.removeClass('active');
	});

	officeIcons.on('click', (event) => {
		var clickedIcon = $(event.currentTarget);
		var iconId = clickedIcon.attr('data-icon-id');
		// updateMapIcon(iconId);
		// updateContactCard(iconId);
	});

	contactCards.on('click', (event) => {
		const clickedCard = $(event.currentTarget);
		const cardId = clickedCard.attr('id');
		// updateMapIcon(cardId);
		// updateContactCard(cardId);
	});

	// Mobile - Opens/Closes Regional Card accordions when the Title is clicked.
	regionalCardTitles.on('click', (event) => {
		const clickedTitle = $(event.currentTarget);
		const clickedCard = clickedTitle.closest('.regionalCard');

		if(clickedCard.hasClass('active')) {
			clickedCard.removeClass('active');
		} else {
			clickedCard.addClass('active');
		}
	});
}
//===================================================================








// ==================================================================
// Animations -> InViewObserver.ts
// ==================================================================
import InViewObserver from './lib/InViewObserver';
InViewObserver.createInstance([
	{
		observeSelector: '.pageContent > .pageMasthead, .pageContent > .wp-block-plaudit-intro',
		minimum: 20,
		minimumUnit: "px"
	},
	{
		observeSelector: '.pageHeading, .processBlocks, .wp-block-media-text, .wp-block-group, .featuredProjects, .wp-block-featuredLink, .timeline, .wp-block-personListing, .cardListing, .wp-block-gallery-text, .testimonial, .map, .post-type-person, .article',
		minimum: 20,
		minimumUnit: "px"
	}
]);
//===================================================================
